// Dependency-free helpers for "which components need the toolbox to be populated".
// Kept OUT of block-constants.ts on purpose: block-constants imports the block components (Playlist,
// Image, ...), so a component that needs this predicate importing block-constants would create a
// circular dependency (NG0919). This file imports nothing, so any component can safely use it.

// aggregator/"player" components that hold their own sub-content (pages/items/scenes) and need the
// toolbox (you drag resources/scenes into them). Collection 4100, Swiper 4101, Playlist 4102,
// Loader 4103, Scheduler 4104, Music-list 4110, HourlyBalancer 4120.
export const TOOLBOX_CONTENT_PLAYER_IDS: ReadonlySet<string> = new Set<string>([
    '4100', '4101', '4102', '4103', '4104', '4110', '4120'
]);

// true for components that need the toolbox to populate them - the aggregator players above plus
// data-provider blocks (JsonPlayer, JsonViewer, Cart, Catalog, Spreadsheet, ...). When such a
// component is edited focused inside a playlist, the toolbox stays open so its content can be filled.
export function requiresToolboxContent(block: { id?: any, dataProviderBlock?: boolean, jsonPlayerBased?: boolean } | null | undefined): boolean {
    if (!block) return false;
    return TOOLBOX_CONTENT_PLAYER_IDS.has(String(block.id))
        || block.dataProviderBlock === true
        || block.jsonPlayerBased === true;
}
